export default "__VITE_ASSET__C6AjglOY__"